import { useLocation } from "react-router";

// api
import { verifyEmail } from "../../services/api/user";

function SignUpVerificationEmailPage() {
    const { state } = useLocation();

    const handleResendEmail = async () => {

        try{
            const res = await verifyEmail(state);
        }catch(err){
            console.error(err);
            if(err.response){
                alert(err.response.data.message);
            }            
        }
    }

    return (
        <div className="SignUpVerificationEmailPage">
            <div>
                We have sent you a <span>verification email.</span>
            </div>
            <div>
                <div>
                    <div>
                        Click the Verify Email button in the verification email
                    </div>                    
                    <div>
                        and click the Confirm Email button below.
                    </div>
                </div>
                <div>
                    Once you verify your email, you will be registered.
                </div>
            </div>
            <div>
                Didn't get the email? <button onClick={handleResendEmail}>Resend the email</button>
            </div>
        </div>
    );
}

export default SignUpVerificationEmailPage;